import React from 'react';
import SalesTimelineDashboard from './SalesTimelineDashboard';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Company Sales Dashboard</h1>
      </header>
      <main>
        <SalesTimelineDashboard />
      </main>
    </div>
  );
}

export default App;
